import { createContext, useContext } from 'react';

/**
 * @typedef {Object} FilterParamsContextState
 * @property {number} page_size
 * @property {string} project
 * @property {number} max_guests_count
 * @property {number} max_children_count
 * @property {number} default_child_age
 * @property {number} max_children_age
 * @property {boolean} sanatorium_seo_page
 * @property {number} default_distance
 * @property {number} max_distance
 * @property {Array} deceases_list
 *
 * @ToDo other properties...
 */

/**
 * @typedef {Object} FilterParamsContextType
 * @property {FilterParamsContextState} filterParams
 * @property {(tagsIds: Array<number>, conditionParam: string) => void} loadAdditionalTags
 * @property {() => void} loadTreatmentProfileFromSearch
 */

/**
 * @type {React.Context<FilterParamsContextType | null>}
 */
export const FilterParamsContext = createContext(null);

/**
 * @return {FilterParamsContextType}
 */
export const useFilterParamsContext = () => {
  const context = useContext(FilterParamsContext);

  if (context == null) {
    throw new Error('Components must be wrapped in <FilterParamsContext.Provider />');
  }

  return context;
};
